/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Rating_NoInputs */

const en_us2_engagement_rating_no = /** @type {(inputs: Engagement_Rating_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_br2_engagement_rating_no = /** @type {(inputs: Engagement_Rating_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const es_419_engagement_rating_no = /** @type {(inputs: Engagement_Rating_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_pt2_engagement_rating_no = /** @type {(inputs: Engagement_Rating_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const fr_fr2_engagement_rating_no = /** @type {(inputs: Engagement_Rating_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_de2_engagement_rating_no = /** @type {(inputs: Engagement_Rating_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const it_it2_engagement_rating_no = /** @type {(inputs: Engagement_Rating_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Engagement_Rating_NoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_rating_no = /** @type {((inputs?: Engagement_Rating_NoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Rating_NoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_rating_no(inputs)
	if (locale === "es-419") return es_419_engagement_rating_no(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_rating_no(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_rating_no(inputs)
	if (locale === "de-DE") return de_de2_engagement_rating_no(inputs)
	if (locale === "it-IT") return it_it2_engagement_rating_no(inputs)
	return en_us2_engagement_rating_no(inputs)
});
export { engagement_rating_no as "engagement.rating_no" }